import { i18n } from '@lingui/core';
import classnames from 'classnames';
import React, { Fragment } from 'react';
import { ReactComponent as CircleLegend } from '../../../assets/images/circle.svg';
import styles from '../FilterSidebar.module.css';

/**
 * Универсальный компонент для динамической фильтрации по атрибуту слоя
 *
 * @param {Object} props
 * @param {string} props.title - Заголовок секции фильтра (например, "Операторы")
 * @param {Array} props.attributeTypes - Массив возможных значений атрибута
 *   Формат: [{ value: 'Yandex', label: Message, fill: '#color' }, ...]
 * @param {Array} props.availableValues - Список доступных значений из загруженных тайлов
 * @param {Array} props.disabledValues - Список отключенных пользователем значений
 * @param {Function} props.onToggle - Callback при переключении чекбокса
 * @param {string} props.inputNamePrefix - Префикс для name и id полей input
 * @param {Function} [props.renderIcon] - Кастомный рендерер иконки: ({ value, fill }) => ReactNode.
 *   Если не передан — рисуется стандартный кружок CircleLegend.
 */
export const DynamicAttributeFilter = ({
    title,
    attributeTypes,
    availableValues = [],
    disabledValues = [],
    onToggle,
    inputNamePrefix = 'dynamic-filter',
    renderIcon,
}) => {
    // Фильтруем только доступные значения
    const itemsToDisplay = attributeTypes.filter(
        ({ value }) => availableValues.includes(value)
    );

    // Если нет доступных значений - не показываем секцию
    if (itemsToDisplay.length === 0) {
        return null;
    }

    return (
        <>
            <div className={styles.legHead}>{title}:</div>
            <div className={styles.checkboxIconGrid}>
                {
                    itemsToDisplay.map(({ value, fill, label }) => {
                        const isChecked = !disabledValues.includes(value);
                        return (
                            <Fragment key={value}>
                                {renderIcon
                                    ? renderIcon({ value, fill })
                                    : (
                                        <CircleLegend
                                            fill={fill}
                                            width='2vw'
                                            height='2vw'
                                            opacity='0.8'
                                        />
                                    )
                                }
                                <label htmlFor={`${inputNamePrefix}-${value}`}>{i18n._(label)}</label>
                                <div>
                                    <label className={styles.switch}>
                                        <input
                                            type='checkbox'
                                            name={inputNamePrefix}
                                            id={`${inputNamePrefix}-${value}`}
                                            checked={isChecked}
                                            value={value}
                                            onChange={onToggle}
                                        />
                                        <span className={classnames(styles.sliderRound, styles.slider)} />
                                    </label>
                                </div>
                            </Fragment>
                        );
                    })
                }
            </div>
        </>
    );
};
